import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { MarketmanagerContactModule } from './contact/contact.module';
import { MarketmanagerBranchModule } from './branch/branch.module';
import { MarketmanagerMarketplaceModule } from './marketplace/marketplace.module';
import { MarketmanagerMarketdayModule } from './marketday/marketday.module';
import { MarketmanagerMarketdateModule } from './marketdate/marketdate.module';
import { MarketmanagerElectricmeterModule } from './electricmeter/electricmeter.module';
import { MarketmanagerBoothfeeModule } from './boothfee/boothfee.module';
import { MarketmanagerEnergyflatModule } from './energyflat/energyflat.module';
import { MarketmanagerAdditionalflatModule } from './additionalflat/additionalflat.module';
import { MarketmanagerSalesunitModule } from './salesunit/salesunit.module';
import { MarketmanagerTestentityModule } from './testentity/testentity.module';
import { MarketmanagerMarketdateStatusModule } from './marketdate-status/marketdate-status.module';
import { MarketmanagerMarketdateCommentModule } from './marketdate-comment/marketdate-comment.module';
import { MarketmanagerContactTempModule } from './contact-temp/contact-temp.module';
import { MarketmanagerMarketdateMeterreadingModule } from './marketdate-meterreading/marketdate-meterreading.module';
import { MarketmanagerMarketdateExpenseModule } from './marketdate-expense/marketdate-expense.module';
import { MarketmanagerBoothModule } from './booth/booth.module';
import { MarketmanagerContractModule } from './contract/contract.module';
import { MarketmanagerMarketdateBoothModule } from './marketdate-booth/marketdate-booth.module';
import { MarketmanagerContractdateModule } from './contractdate/contractdate.module';
/* jhipster-needle-add-entity-module-import - JHipster will add entity modules imports here */

@NgModule({
    imports: [
        MarketmanagerContactModule,
        MarketmanagerBranchModule,
        MarketmanagerMarketplaceModule,
        MarketmanagerMarketdayModule,
        MarketmanagerMarketdateModule,
        MarketmanagerElectricmeterModule,
        MarketmanagerBoothfeeModule,
        MarketmanagerEnergyflatModule,
        MarketmanagerAdditionalflatModule,
        MarketmanagerSalesunitModule,
        MarketmanagerTestentityModule,
        MarketmanagerMarketdateStatusModule,
        MarketmanagerMarketdateCommentModule,
        MarketmanagerContactTempModule,
        MarketmanagerMarketdateMeterreadingModule,
        MarketmanagerMarketdateExpenseModule,
        MarketmanagerBoothModule,
        MarketmanagerContractModule,
        MarketmanagerMarketdateBoothModule,
        MarketmanagerContractdateModule,
        /* jhipster-needle-add-entity-module - JHipster will add entity modules here */
    ],
    declarations: [],
    entryComponents: [],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerEntityModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/entity.module.ts